import {
  IdentityDocumentFieldKey,
  IdentityDocumentFieldType,
  IdentityDocumentPermission,
  IdentityDocumentType
} from '@app/entities/enums/personal-data/personal-data.enum';

export class IdentityDocumentField {
  key!: IdentityDocumentFieldKey;
  type!: IdentityDocumentFieldType;
  value!: string;
  editable!: boolean;
}

export class IdentityDocument {
  id!: string | null;
  type!: IdentityDocumentType;
  shortName!: string;
  isPrincipal!: boolean;
  permissionType!: IdentityDocumentPermission | null;
  fields!: IdentityDocumentField[];
  canEdit!: boolean;
  canDelete!: boolean;
}
